import * as React from "react";
import { MuiList, useInterstateToken } from "@dealer-center/core-components";
import { useNavigate } from "react-router-dom";
import { buildNavMenuRoot, colorNames } from "./helper";
import { useNavBarStore } from "../../store";
import type { NavigationMenuItemInterface } from "@dealer-center/ddc-api-commoncontainer-interface";

export interface LinksMenuProps {
  closeNavbar: () => void;
}
export interface handleNavMenuClickReturnType {
  url: string;
  action: "open" | "navigate" | "redirect" | "none";
}
export const handleNavMenuClick = (
  link: NavigationMenuItemInterface
): handleNavMenuClickReturnType => {
  const defailtReturn: handleNavMenuClickReturnType = {
    url: "",
    action: "none"
  };
  if (!link) return defailtReturn;
  switch (link.linkType) {
    case "header":
      return defailtReturn;
    case "open":
      return { url: link.link, action: "open" };
    case "navigate":
      return { url: link.link, action: "navigate" };
    case "redirect":
      return { url: link.link, action: "redirect" };
    default:
      return defailtReturn;
  }
};
export function LinksMenuNew({ closeNavbar }: LinksMenuProps) {
  const { linksMenu } = useNavBarStore();
  const navigate = useNavigate();
  const getToken = useInterstateToken();
  const [expandedIndexs, setExpandedIndexs] = React.useState<string[]>([]);

  if (!linksMenu) return null;
  const onMenuItemClick = (params: { link: NavigationMenuItemInterface }) => {
    const { url, action } = handleNavMenuClick(params.link);
    switch (action) {
      case "open":
        window.open(url, "_blank");
        break;
      case "navigate":
        navigate(url);
        break;
      case "redirect":
        window.location.href = url;
        break;
      case "none":
        break;
    }
    closeNavbar();
  };
  const handleExpandClick = (index?: string) => {
    if (!index) return;
    if (expandedIndexs.includes(index)) {
      setExpandedIndexs(expandedIndexs.filter(i => i !== index));
    } else {
      setExpandedIndexs([...expandedIndexs, index]);
    }
  };

  return (
    <MuiList
      dense
      component="nav"
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: getToken(colorNames.background),
        color: getToken(colorNames.color)
      }}
    >
      {buildNavMenuRoot(
        handleExpandClick,
        expandedIndexs,
        onMenuItemClick,
        linksMenu,
        colorNames
      )}
    </MuiList>
  );
}
